import 'css-chunksrc/client/scenes/listDuplication/listsList/list/milestone/styles.scss';export default {
  "milestone": "_milestone_ewibz_1",
  "contextualMenu": "_contextualMenu_ewibz_8",
  "milestoneDetails": "_milestoneDetails_ewibz_12",
  "name": "_name_ewibz_22",
  "icon": "_icon_ewibz_38",
  "taskAdvancement": "_taskAdvancement_ewibz_42",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_ewibz_48",
  "removeIcon": "_removeIcon_ewibz_61",
  "status": "_status_ewibz_65",
  "allocations": "_allocations_ewibz_72",
  "text": "_text_ewibz_79",
  "tick": "_tick_ewibz_85",
  "late": "_late_ewibz_92",
  "completed": "_completed_ewibz_96",
  "displayContextualMenu": "_displayContextualMenu_ewibz_107",
  "placeholder": "_placeholder_ewibz_111"
};